import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconZap: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconZap"><Path d="M14.0019 0.238159L2.25781 16H10.0019V23.7619L21.7461 8.00001H14.0019V0.238159Z" fill="currentColor"/></CentralIconBase>;
});

export default IconZap;
